import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { Projects, Supportrequestsinfo } from '@usimweb/core/models';

@Component({
    selector: 'usimweb-project-menu',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './project-menu.component.html',
    styleUrls: ['./project-menu.component.scss'],
    standalone: false
})
export class ProjectMenuComponent implements OnInit {
  @Input() project: Projects = {} as Projects;

  @Input() color!: string;

  @Output() updateSupported: EventEmitter<any> = new EventEmitter<any>();

  @Output() dialogEvent: EventEmitter<any> = new EventEmitter<any>();

  public projectSupported = false;
  public additionalFeatures = true;

  constructor() {}

  ngOnInit(): void {
    const support = this.project.support_requests_info;
    this.projectSupported = support![0]?.is_open === true ? true : false;
  }

  private isProjectSupported(support: Supportrequestsinfo[]) {
    for (const supportRequest of support) {
      let allowStatuses = ['new_request', 'in_progress'];
      if (allowStatuses.includes(supportRequest.status)) {
        return true;
      }
    }
    return false;
  }

  public openShareDialog(uuid: string) {
    this.dialogEvent.emit({ event: 'share', uuid: uuid, data: this.project });
  }

  public deleteProject(uuid: string) {
    this.dialogEvent.emit({ event: 'delete', uuid: uuid, data: this.project });
  }

  public requestSupport(uuid: string) {
    const name = this.project.name;

    this.dialogEvent.emit({
      event: 'request_support',
      uuid: uuid,
      data: this.project,
      title: 'Request support: ' + name,
    });
  }

  public viewSupportRequest(uuid: string) {
    const name = this.project.name;

    this.dialogEvent.emit({
      event: 'view_support',
      uuid: uuid,
      data: this.project,
      title: 'View support request: ' + name,
    });
  }
}
